import {action} from 'typesafe-actions';
import {ModuloTypes} from './types';

export const selecionarModulo = (modulo: string | null) => action(ModuloTypes.SELECIONAR, modulo);
